import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { RefundReportWidget } from "@/widgets/refund/RefundReportWidget";

export function RefundReportPage() {
  const { _id } = useParams<{ _id: string }>();
  useEffect(() => {
    document.title = "Буцаалтын тайлан";
  }, []);
  return (
    <div className="page">
      <RefundReportWidget key={_id} id={_id} />
    </div>
  );
}
